import React, { lazy, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { isContainerLoadedInDOM, noop } from '../../../../lib/utilities';
import ErrorBoundary from '../../../_modules/error/error_boundary';
import { Provider } from '../../../_views/global_context';
const FittingStationFinderApp = React.lazy(() => import('./fitting_station_finder_app'));

function renderFittingStationFinder({
    containerDOMNode,
    showSelectStationButton = false,
    showSuccessPage = false,
    showDisplayName = false,
    showQuantityInput = false,
    onStationSelect = noop,
    onWheels2Change = noop,
    onWheels4Change = noop
}) {
    TYROOLA.mapsInitiated.then(() => {
        if (!isContainerLoadedInDOM(containerDOMNode)) {
            TYROOLA.root[containerDOMNode.id] = createRoot(containerDOMNode);
        }
        return TYROOLA.root[containerDOMNode.id].render(<Provider value={TYROOLA.globals}>
            <ErrorBoundary>
                <Suspense fallback={<div>Loading...</div>}>
                    <FittingStationFinderApp
                        showSelectStationButton={showSelectStationButton}
                        showSuccessPage={showSuccessPage}
                        showDisplayName={showDisplayName}
                        showQuantityInput={showQuantityInput}
                        onStationSelect={onStationSelect}
                        onWheels2Change={onWheels2Change}
                        onWheels4Change={onWheels4Change}
                    />
                </Suspense>
            </ErrorBoundary>
        </Provider>);
    });
}

export { renderFittingStationFinder };
